export default "__VITE_ASSET__UWYtx5zl__"